import React from 'react';
import GlobalPackageIndex from 'components/package/GlobalPackageIndex/GlobalPackageIndex';

const Themes = () => 
  <GlobalPackageIndex type="theme"></GlobalPackageIndex>

export default Themes;
